
  import { computed, defineComponent, onBeforeUnmount, onMounted, Ref, ref } from 'vue';
  import { Button, Hint, Icon, Input, Numpad, Typography } from '@voximplant/spaceui';
  import { useI18n } from 'vue-i18n';
  import { useStore } from 'effector-vue/composition';
  import { $settings } from '@/store/settings/index';
  import { numpadList } from '@/lib/numpadButtonList';
  import { $dialingComponentStatus } from '@/store/components/index';
  import {
    $phoneInput,
    actionOnBtn,
    changeInputState,
    changeInputValue,
  } from '@/store/softphone/index';
  import '@/store/softphone/init';
  import '@/store/settings/onDeviceChange';
  import { needToShowAdditionalButton } from '@/store/NeedToShowAdditionalButton';
  import { onFocusInputPhone } from '@/store/hooks/focus';
  import {
    $currentActiveCallId,
    $currentSelectCallId,
    activeCalls,
    currentSelectCall,
    openCallState,
  } from '@/store/calls';
  import appConfig from '@/config';
  import ActiveCall from '@/components/calls/ActiveCall.vue';

  const __default__ = defineComponent({
    name: 'Dialing',
    components: { Typography, Button, Input, Numpad, Hint, Icon, ActiveCall },
    setup() {
      const { t } = useI18n();
      const phoneNumberInput = ref<HTMLFormElement | null>(null);
      const phoneInput = useStore($phoneInput);
      const currentActiveCallId = useStore($currentActiveCallId);
      const currentSelectCallId = useStore($currentSelectCallId);
      const selectCall = useStore(currentSelectCall);
      const callsStore = useStore(activeCalls);
      const settingsState = useStore($settings);
      const dialingStatus = useStore($dialingComponentStatus);
      const showAdditionalButton = useStore(needToShowAdditionalButton);

      // flags
      const showVideoButton = computed(
        () =>
          dialingStatus.value !== 'toneDial' &&
          !settingsState.value.minimize &&
          !appConfig.AUDIO_ONLY
      );

      // buttons action
      const onAdditionalButton = () => {
        if (dialingStatus.value === 'firstCall') actionOnBtn('primary');
        else openCallState(currentActiveCallId.value);
      };
      const onToneDialClick = () => {
        if (dialingStatus.value === 'toneDial') {
          actionOnBtn('primary');
        } else {
          phoneInput.value.inputValue ? actionOnBtn('primary') : changeInputState('error');
        }
      };

      // classes and styles
      const dialingClasses = computed(() => ({
        'dialing-collapse': settingsState.value.minimize,
      }));
      const dialingContentGap: Ref<string> = computed(() => {
        if (settingsState.value.minimize) return '16px';
        return appConfig.IS_CUSTOMIZE && !callsStore.value.length ? '56px' : '0';
      });
      const dialingHeight = computed(() => (settingsState.value.maximize ? 'fit-content' : '100%'));

      onMounted(() => {
        document.addEventListener('keydown', (event) => {
          onFocusInputPhone(event, phoneNumberInput.value?.inputRef);
        });
      });

      onBeforeUnmount(() => {
        document.removeEventListener('keydown', (event) => {
          onFocusInputPhone(event, phoneNumberInput.value?.inputRef);
        });
      });

      return {
        t,
        numpadList,
        dialingClasses,
        changeInputValue,
        actionOnBtn,
        phoneInput,
        onAdditionalButton,
        dialingStatus,
        showAdditionalButton,
        showVideoButton,
        settingsState,
        phoneNumberInput,
        changeInputState,
        openCallState,
        currentActiveCallId,
        currentSelectCallId,
        callsStore,
        dialingContentGap,
        onToneDialClick,
        dialingHeight,
        selectCall,
      };
    },
  });

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "07bdb8a3": (_ctx.dialingHeight),
  "7b9d25ce": (_ctx.dialingContentGap)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__